/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useEffect, useState } from "react";
import socket from "../Utils/Socket";



export const CacheWebsocketContext = createContext<any>({
  shouldUpdate: false,
  setShouldUpdate: (value: boolean) => {},
});

export const CacheWebsocketProvider = (props: any) => {
  const setShouldUpdate = (shouldUpdate: boolean) => {
    setState({ ...state, shouldUpdate: shouldUpdate });
  };
  const initState = {
    shouldUpdate: false,
    setShouldUpdate: setShouldUpdate,
  };
  const [state, setState] = useState(initState);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token && token !== "") {
      socket.emit("cacheData");
      socket.on("cache", (data) => {
        localStorage.setItem("cache", JSON.stringify(data));
        const event = new Event("storage");
        window.dispatchEvent(event);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.shouldUpdate]);

  return (
    <CacheWebsocketContext.Provider value={state}>
      {props.children}
    </CacheWebsocketContext.Provider>
  );
};
